import {
  Badge,
  Card,
  Group,
  Loader,
  Stack,
  Text,
  ThemeIcon,
} from "@mantine/core";
import { Sparkline } from "@mantine/charts";
import { IconTrendingDown, IconTrendingUp } from "@tabler/icons-react";

// Panelin özet kartı. Değer `undefined` iken yükleniyor gösteriyor — çağıranların ayrı bir
// iskelet kurmasına gerek kalmıyor.
export function StatCard({
  label,
  value,
  icon: Icon,
  color,
  hint,
  trend,
  spark,
}) {
  return (
    <Card withBorder radius="md" padding="lg">
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Stack gap={2} style={{ minWidth: 0 }}>
          <Text size="xs" tt="uppercase" fw={700} c="dimmed">
            {label}
          </Text>
          {value === undefined ? (
            <Loader size="sm" mt={8} />
          ) : (
            <Text fz={32} fw={800} lh={1.1} truncate data-tabular>
              {value}
            </Text>
          )}
          {(hint || trend != null) && (
            // Sparkline yanında yer kalmayınca hem yüzde hem açıklaması kırpılıyordu
            // ("-35.4…" / "geçen aya gö…"). Rozet artık daralmıyor, açıklama sığmazsa
            // alt satıra iniyor: sayı da gerekçesi de eksiksiz okunuyor.
            <Group gap={6} mt={4}>
              {trend != null && (
                <Badge
                  size="sm"
                  radius="sm"
                  variant="light"
                  color={trend >= 0 ? "teal" : "red"}
                  style={{ flexShrink: 0 }}
                  leftSection={
                    trend >= 0 ? (
                      <IconTrendingUp size={12} />
                    ) : (
                      <IconTrendingDown size={12} />
                    )
                  }
                >
                  {`${trend >= 0 ? "+" : ""}${trend.toFixed(1)}%`}
                </Badge>
              )}
              {hint && (
                <Text size="xs" c="dimmed">
                  {hint}
                </Text>
              )}
            </Group>
          )}
        </Stack>
        {spark?.length ? (
          <Sparkline
            w={90}
            h={46}
            data={spark}
            curveType="monotone"
            withGradient
            fillOpacity={0.25}
            strokeWidth={1.6}
            trendColors={{
              positive: "teal.6",
              negative: "red.6",
              neutral: "gray.5",
            }}
          />
        ) : (
          <ThemeIcon size={46} radius="md" variant="light" color={color}>
            <Icon size={24} stroke={1.6} />
          </ThemeIcon>
        )}
      </Group>
    </Card>
  );
}
